// frontend\src\pages\Calculators\Calculators.js
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DevelopmentTime from './components/DevelopmentTime';
import VolumeMixer from './components/VolumeMixer';
import TemperatureTime from './components/TemperatureTime';
import Exposure from './components/Exposure';
import ScrollToTopButton from "../../components/ScrollToTopButton";

const Calculators = () => {
  const location = useLocation();
  const [activeCalculator, setActiveCalculator] = useState('development');
  const [result, setResult] = useState('');
  const [initialTemperatureData, setInitialTemperatureData] = useState(null);

  useEffect(() => {
    if (location.state) {
      const { calculator, ...data } = location.state;
      if (calculator) {
        setActiveCalculator(calculator);
      }
      if (calculator === 'temperature') {
        setInitialTemperatureData(data);
      }
    }
  }, [location.state]);

  const handleCalculatorChange = (calculator) => {
    setActiveCalculator(calculator);
    setResult('');
    setInitialTemperatureData(null);
  };
  
  const calculators = {
    development: <DevelopmentTime onCalculate={setResult} />,
    volume: <VolumeMixer onCalculate={setResult} />,
    temperature: (
      <TemperatureTime 
        onCalculate={setResult} 
        initialBaseTime={initialTemperatureData?.baseTime}
        initialBaseTemp={initialTemperatureData?.baseTemp}
        initialFilmType={initialTemperatureData?.filmType}
      />
    ),
    exposure: <Exposure onCalculate={setResult} />
  };

  return (
    <div className="container mt-4">
      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button 
            className={`nav-link ${activeCalculator === 'development' ? 'active' : ''}`}
            onClick={() => handleCalculatorChange('development')}
          >
            Время проявки
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeCalculator === 'volume' ? 'active' : ''}`}
            onClick={() => handleCalculatorChange('volume')}
          >
            Смешивание растворов
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeCalculator === 'temperature' ? 'active' : ''}`}
            onClick={() => handleCalculatorChange('temperature')}
          >
            Температурная коррекция
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeCalculator === 'exposure' ? 'active' : ''}`}
            onClick={() => handleCalculatorChange('exposure')}
          >
            Экспозиция
          </button>
        </li>
      </ul>
      
      <div className="card">
        <div className="card-body">
          {calculators[activeCalculator]}
        </div>
      </div>
      
      {result && (
        <div className="card mt-4">
          <div className="card-body">
            {result}
          </div>
        </div>
      )}
      <ScrollToTopButton/>
    </div>
  );
};

export default Calculators;